
	import { defineComponent, PropType, Ref, ref } from 'vue';

	import { CustodyResidentialService } from '@/Services/custody-residential-service';
	import { DateHelper } from '@/Services/Helper/date-helper';
	import { ValidationHelper } from '@/Services/Helper/validation-helper';

	import { ICustodyResidential, ICustodyResidentialForEdit } from '@/Models/ICustodyResidential';
	import { MasterLookupWrapper } from '@/Models/Lookup/MasterLookupWrapper';
    import { CustodyResidentialTypes } from "@/Enums/CustodyResidentialTypes";

	import ValidationAlert from '@/ChildrenComponents/ValidationAlert.vue';

	export default defineComponent({
		name: "phase-custody-residential-dialog",
		components: { ValidationAlert },
		emits: ["close", "saved"],
		props: {
			lookups: {
				type: Object as PropType<MasterLookupWrapper>,
				required: true
			},
			source: {
				type: Object as PropType<ICustodyResidential>,
				required: true
			},
		},
		setup(): { form: Ref } {
			const form = ref(null);
			return { form };
		},
		created() {
			this.setDto();
			this.typeList = [CustodyResidentialTypes.InCustody, CustodyResidentialTypes.InResidential, CustodyResidentialTypes.Suspension]
		},
		data () {
			return {
				requiredFieldRules: ValidationHelper.requiredRules,
				dto: {} as ICustodyResidentialForEdit,
				typeList: [] as CustodyResidentialTypes[],
				errors: [] as string[],
				isSaving: false,
			}
		},
		methods: {
			setDto(): void {
				this.dto = JSON.parse(JSON.stringify(this.source)) as ICustodyResidentialForEdit;
				this.dto.startDateForEdit = DateHelper.formatDateUtc(this.dto.startDate, "yyyy-MM-dd");
				this.dto.endDateForEdit = DateHelper.formatDateUtc(this.dto.endDate, "yyyy-MM-dd");
                this.dto.targetEndDateForEdit = DateHelper.formatDateUtc(this.dto.targetEndDate, "yyyy-MM-dd");
				if (this.form != null) {
					//adding a brief delay to make sure the changes to startDateForEdit have fully registered before resetting validation
					setTimeout(() => { this.form.resetValidation(); }, 100);
				}
			},
			prepForSave(): void {
				this.dto.startDate = DateHelper.standardizeDate(this.dto.startDateForEdit);
				this.dto.endDate = DateHelper.standardizeDate(this.dto.endDateForEdit);
				this.dto.targetEndDate = DateHelper.standardizeDate(this.dto.targetEndDateForEdit);
			},
			closeDialog(): void {
				this.$emit("close");
			},
			async save(startNew: boolean) {
				const { valid } = await this.form.validate();
				if (valid) {
					this.prepForSave();
					this.isSaving = true;
					CustodyResidentialService.save(this.dto)
						.then(result => {
							this.errors = result.messages;
							if (result.isValid && result.resultObject != null) {
								this.$emit("saved", result.resultObject, startNew);
							}
						})
						.catch(error => this.errors.push(error))
						.finally(() => this.isSaving = false);
				}
			},
		},
		computed: {
			buttonText1(): string {
				return this.isSaving ? "Saving..." : "Save and Close";
			},
            titleText(): string {
                return this.dto.custodyOrResidential.toString().replace("In", "In ");
            },
			endDateRules() {
				return [
					(v : string) => {
						if (this.dto && v != "") {
							const startDate = new Date(this.dto.startDateForEdit);
							const endDate = new Date(v);
							return !startDate || endDate >= startDate || 'End Date cannot be before Start Date';
						}
						return true; // Return true if this.dto is null
					}
				];
			},
		},
		watch: {
			source() {
				this.setDto();
			},
			// 'dto.startDateForEdit': {
			// 	handler(value) {
			// 		if (this.dto && !this.dto?.endDateForEdit) {
			// 			this.dto.endDateForEdit = value;
			// 		}
			// 	},
			// 	deep: true
			// },
		},
	});
